import React from 'react';

import { ResultBadgeContainer } from './styles';

interface ResultBadgeProps {
	value?: JSX.Element | string | number;
	fallback?: JSX.Element | string | number;
	children?: JSX.Element | string | number;
}

export function ResultBadge({ value, fallback = '-', children }: Readonly<ResultBadgeProps>) {
	const content = value ?? children ?? fallback;

	return (
		<ResultBadgeContainer>
			<p>{content}</p>
		</ResultBadgeContainer>
	);
}
